import  gql  from 'graphql-tag'

export const CREATE_CREDIT_TYPE = gql`mutation creditType($input: CreditTypeMutationInput!){
    creditType(input: $input){
        creditType{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;